/** The audio module's public types (docs/spec/04 §5, 05 §4). Re-exported from `index.ts`. */

import type { SimEvent } from '../sim/types';

export type MusicTrack = 'title' | 'start' | 'empress' | 'hiscore' | 'gameover';
export type UiSound = 'move' | 'select' | 'back' | 'error' | 'type';

/** Continuous sounds, set every tick. */
export interface Ambience {
  beam: boolean;
  lance: boolean;
}

/** Each 0..1. */
export interface Volumes {
  master: number;
  sfx: number;
  music: number;
}

/** Options' defaults (04 §6: 8 / 8 / 6 out of 10). */
export const DEFAULT_VOLUMES: Volumes = { master: 0.8, sfx: 0.8, music: 0.6 };

export interface GameAudio {
  /** Call on every key / click / touch: resumes the AudioContext on the first one. */
  unlock(): void;
  /** One tick's events (the game runs 60 ticks a second; most ticks have none). */
  events(events: readonly SimEvent[]): void;
  ambience(a: Ambience): void;
  ui(s: UiSound): void;
  /** Crossfade to a track (null = silence). 'start' and 'gameover' play once; the others loop. */
  music(track: MusicTrack | null): void;
  setVolumes(v: Volumes): void;
  /** Stop ambience and let ringing effects die quickly (pause, leaving the game). */
  hush(): void;
  /** Music files found in /music, for the console. */
  tracks(): string[];
}
